import { useQuery } from '@tanstack/react-query';

import { getLiveAnalysisConfig } from '@data';

import { useLiveAnalysisEnabled } from './useLiveAnalysisEnabled';

export const getLiveAnalysisConfigKey = () => ['live-feedback', 'config'];

type ConfigParameter = { id: number };

type Config = { parameters: ConfigParameter[]; tareCountDown: number };

export const useLiveAnalysisConfig = () => {
    const { data: { enabled } = {} } = useLiveAnalysisEnabled();
    return useQuery<Config>({
        queryKey: getLiveAnalysisConfigKey(),
        queryFn: () => getLiveAnalysisConfig(),
        enabled,
    });
};
